import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { HisResourcePropertyDisplayInputs } from '../../model/his-resource-property-display.model';
import { ResourcePropertyDetail } from '../../model/resource-property-detail.model';
import { HisResourcePropertyDisplayService } from '../../service/his-resource-property-display.service';

/**
 * Renders the properties of a resource category inside the properties overlay, and nothing at
 * all for a category without such a display — the caller falls back to the generic key/value
 * list then.
 *
 * This is the Angular counterpart of the JSF {@code selectFile-metadata.xhtml}: instead of
 * switching on the category key it looks the display up in the
 * {@link HisResourcePropertyDisplayService}.
 */
@Component( {
    standalone: false,
    selector: 'his-select-file-metadata',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './his-select-file-metadata.component.html',
} )
export class HisSelectFileMetadataComponent {

    /** The category to be presented. */
    readonly categoryKey = input.required<string>();

    /** The properties of that category. */
    readonly details = input.required<ResourcePropertyDetail[]>();

    private readonly displays = inject( HisResourcePropertyDisplayService );

    protected readonly display = computed( () => this.displays.detailsOf( this.categoryKey() ) );

    protected readonly inputs = computed<HisResourcePropertyDisplayInputs>( () => ( { details: this.details() } ) );
}
